export default "__VITE_ASSET__19ca55b0__"